import ErrorPage from 'next/error'
import { useRouter } from 'next/router'

import Quiz from '@/components/Quiz'
import SanityPreview from '@/components/SanityPreview'
import SEO from '@/components/SEO'
import useColor from '@/hooks/useColor'
import { buildGetStaticPaths, buildGetStaticProps } from '@/lib/page'
import { quizBySlugQuery } from '@/queries/quiz'
import type { QuizBySlugQueryResult } from '../../../sanity.types'

const query = quizBySlugQuery

export default function Page({
  preview,
  pageData,
  error,
  status,
  slug,
}: SanityPageProps<QuizBySlugQueryResult, { slug: string; status: string }>) {
  const router = useRouter()

  useColor(pageData, status)

  if (!router.isFallback && !pageData) {
    return <ErrorPage statusCode={404} />
  }

  if (error) {
    return <ErrorPage statusCode={error.statusCode} title={error.title} />
  }

  return (
    <SanityPreview preview={preview} initialData={pageData} query={query} params={{ slug }}>
      {(quiz) => {
        return (
          <div>
            <SEO
              title={quiz?.title}
              description={quiz?.preamble}
              path={`quiz/${quiz?.slug?.current}`}
              excludeFromSearch={quiz?.excludeFromSearch}
            />

            {quiz && <Quiz {...quiz} questions={quiz.questions ?? undefined} />}
          </div>
        )
      }}
    </SanityPreview>
  )
}

export const getStaticProps = buildGetStaticProps<QuizBySlugQueryResult>(quizBySlugQuery)

export const getStaticPaths = buildGetStaticPaths('quiz')
